<template>
  <a-drawer
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :destroyOnClose="true"
    :maskClosable="true"
    placement="right"
    @close="close"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item label="名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            type="text"
            :max-length="15"
            v-decorator="[
              'pageName',
              {
                rules: [
                  { required: true, message: '请输入页面名称,限制15个字' },
                ],
              },
            ]"
            placeholder="请输入页面名称"
          />
        </a-form-item>
        <a-form-item label="描述" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-textarea
            type="text"
            :max-length="200"
            rows="3"
            v-decorator="['pageDescribe']"
            placeholder="请输入页面描述,限制200字"
          />
        </a-form-item>

        <a-form-item
          label="起止时间"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-range-picker
            format="YYYY-MM-DD HH:mm:ss"
            :disabled-date="disabledDate"
            v-decorator="['pageStartEndTime']"
            :show-time="{
              hideDisabledOptions: true,
              defaultValue: [
                moment('00:00:00', 'HH:mm:ss'),
                moment('11:59:59', 'HH:mm:ss'),
              ],
            }"
          />
        </a-form-item>

        <a-form-item :wrapperCol="wrapperCol">
          <a-button
            style="margin-left: 40px"
            @click="handleAddModules"
            type="primary"
            icon="plus"
            >添加模块</a-button
          >
        </a-form-item>
        <a-form-item
          label="模块"
          v-for="(item, index) in arr2"
          :key="index"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            option-filter-prop="children"
            :filter-option="filterOption"
            show-search
            mode="multiple"
            v-model="pageModuleIds[index]"
            placeholder="请选择需要使用的模块"
            style="width: 60%; margin-left: 0px; margin-top: 5px"
          >
            <a-select-option
              v-for="(item, index) in moduleList"
              :value="item.id"
              :key="index"
              >{{ item.eventName }}</a-select-option
            >
          </a-select>
          <a-button
            style="margin-left: 50px"
            @click="handleDelModules(index)"
            icon="minus"
            >删除</a-button
          >
        </a-form-item>

        <a-form-item
          label="是否关联用户金币信息"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-switch
            checked-children="是"
            un-checked-children="否"
            v-model="pageGoldFlag"
            @change="changeHandler3"
          />
        </a-form-item>

        <a-form-item
          label="公用参数"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-switch
            checked-children="有"
            un-checked-children="无"
            v-model="pageCommonConfigFlag"
            @change="changeHandler"
          />
        </a-form-item>
        <a-form-item
          v-if="pageCommonConfigFlag"
          label="规则"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            v-decorator="['pageRules']"
            placeholder="请选择关联的规则"
          >
            <a-select-option
              v-for="(item, index) in ruleList"
              :value="item.id"
              :key="index.id"
              >{{ item.ruleName }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item
          v-if="pageCommonConfigFlag"
          label="跑马灯"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            mode="multiple"
            v-decorator="['pageHorseRaceLamp']"
            placeholder="请选择关联跑马灯"
          >
            <a-select-option
              v-for="(item, index) in horseRaceLampList"
              :value="item.id"
              :key="index.id"
              >{{ item.pmdName }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item
          v-if="pageCommonConfigFlag"
          label="Banner图"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            mode="multiple"
            v-decorator="['pageBanner']"
            placeholder="请选择关联Banner图"
          >
            <a-select-option
              v-for="(item, index) in bannerList"
              :value="item.id"
              :key="index.id"
              >{{ item.title }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <!--<a-form-item v-if="pageCommonConfigFlag" label="产品卡" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select mode="multiple" v-decorator="['pageProductCard']" placeholder="请选择关联产品卡(默认按添加顺序进行排序)">
            <a-select-option v-if="cardsList != null" v-for="(item, index) in cardsList" :value="item.id" :key="index.id">{{item.productName}}</a-select-option>
          </a-select>
        </a-form-item>-->

        <a-form-item
          label="暂停信息"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-switch
            checked-children="有"
            un-checked-children="无"
            v-model="pageStopFlag"
            @change="changeHandler2"
          />
        </a-form-item>
        <a-form-item
          v-if="pageStopFlag"
          label="暂停信息类型"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            v-decorator="[
              'pageStopType',
              { rules: [{ required: true, message: '请输入暂停信息类型' }] },
            ]"
            placeholder="暂停信息类型"
            @change="fieldValue"
          >
            <a-select-option
              v-for="(item, index) in activityStopFlagType"
              :value="item.value"
              :key="index"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item
          v-if="pageStopFlag && stopImgShow"
          label="暂停维护图"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <UploadImage
            @handleFileList="handleImageList"
            v-decorator="[
              'pageStopImg',
              { rules: [{ required: true, message: '请上传暂停维护图' }] },
            ]"
          ></UploadImage>
        </a-form-item>
        <a-form-item
          v-if="pageStopFlag && stopTextShow"
          label="暂停文字描述"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-textarea
            type="text"
            :max-length="500"
            rows="4"
            v-decorator="[
              'pageStopMessage',
              { rules: [{ required: true, message: '请输入暂停文字描述' }] },
            ]"
            placeholder="请输入页面暂停描述,限制500字"
          />
        </a-form-item>
        <a-form-item
          v-if="pageStopFlag"
          label="暂停跳转地址"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            v-decorator="['pageStopJumpUrl']"
            placeholder="请输入引导用户跳转地址"
          />
        </a-form-item>
      </a-form>
    </a-spin>
    <div class="drawer-bootom-button">
      <a-popconfirm
        title="确定放弃编辑？"
        @confirm="handleCancel"
        okText="确定"
        cancelText="取消"
      >
        <a-button style="margin-right: 0.8rem">取消</a-button>
      </a-popconfirm>
      <a-button @click="handleOk" type="primary">提交</a-button>
    </div>
  </a-drawer>
</template>

<script>
import { httpAction } from '@/api/manage';
import pick from 'lodash.pick';
// import { validateDuplicateValue } from '@/utils/util';
import JDate from '@/components/jeecg/JDate';
import JImageUpload from '@/components/jeecg/JImageUpload';
import JMultiSelectTag from '../../../../components/dict/JMultiSelectTag';
import moment from 'moment';
import { getAction, postTag } from '../../../../api/manage';
import UploadImage from '@/components/common/UploadImage';

export default {
  name: 'PageModuleModal',
  components: {
    JMultiSelectTag,
    JDate,
    JImageUpload,
    UploadImage,
  },
  data() {
    return {
      fileList: '',
      pageCommonConfigFlag: true, //公用参数配置开关,默认打开
      ruleList: [], //规则列表
      horseRaceLampList: [], //跑马灯列表
      bannerList: [], //banner类型
      //cardsList:[],//产品卡

      modelId: '',
      arr2: [1],
      moduleList: [], //模块集合
      pageModuleIds: [], //添加的模块集合

      pageStopFlag: true, //暂停信息配置开关,默认打开
      activityStopFlagType: [
        {
          name: '弹框',
          value: 1,
        },
        {
          name: '图片',
          value: 2,
        },
      ],
      stopImgShow: false,
      stopTextShow: false,

      pageGoldFlag: false, //用户金币信息开关，默认关闭

      headers: {
        authorization: 'authorization-text',
      },
      category: '0',
      form: this.$form.createForm(this),
      title: '操作',
      width: 800,
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      validatorRules: {},
      url: {
        add: process.env.VUE_APP_CMS_MARKETING + '/page/modules/add',
        edit: process.env.VUE_APP_CMS_MARKETING + '/page/modules/edit',
        updateMiddle:
          process.env.VUE_APP_CMS_MARKETING + '/page/modules/updateMiddle',
        getMiddleByPageId:
          process.env.VUE_APP_CMS_MARKETING + '/page/modules/getMiddleByPageId',
      },
    };
  },
  created() {},
  methods: {
    moment,
    add() {
      this.edit({});
    },

    edit(record) {
      console.log(record);
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      if (record.pageStopImg) {
        this.fileList = record.pageStopImg;
      }
      if (this.model.pageHorseRaceLamp) {
        this.model.pageHorseRaceLamp = this.model.pageHorseRaceLamp.split(',');
      } else {
        this.model.pageHorseRaceLamp = [];
      }
      if (this.model.pageBanner) {
        this.model.pageBanner = this.model.pageBanner.split(',');
      } else {
        this.model.pageBanner = [];
      }
      /*if (this.model.pageProductCard){
          this.model.pageProductCard = this.model.pageProductCard.split(",");
        }else {
          this.model.pageProductCard = [];
        }*/

      //初始化字段
      this.editInitFields(this.model);

      this.$nextTick(() => {
        this.form.setFieldsValue({
          pageStopImg:
            record.pageStopImg && record.pageStopImg.indexOf('http') != -1
              ? record.pageStopImg
              : process.env.VUE_APP_FILE_PATH + record.pageStopImg,
        });
        this.form.setFieldsValue(
          pick(
            this.model,
            'pageName',
            'pageDescribe',
            'pageCommonConfigFlag',
            'pageStopFlag',
            'pageRules',
            'pageHorseRaceLamp',
            'pageBanner',
            'pageStartEndTime',
            'pageStopType',
            'pageStopMessage',
            // 'pageStopImg',
            'pageStopJumpUrl',
            'pageGoldFlag'
          )
        );
      });
      if (this.model.pageStopType === 1) {
        this.stopTextShow = true;
        this.stopImgShow = false;
      } else if (this.model.pageStopType === 2) {
        this.stopImgShow = true;
        this.stopTextShow = false;
      } else {
        this.stopImgShow = false;
        this.stopTextShow = false;
      }

       if (this.model.pageGoldFlag === 1) {
        this.pageGoldFlag = true;
      } else {
        this.pageGoldFlag = false;
      }
      if (this.model.pageStartEndTime) {
        let ary = this.model.pageStartEndTime.split('~');
        this.model.pageStartEndTime = [
          moment(ary[0], 'YYYY-MM-DD HH:mm:ss'),
          moment(ary[1], 'YYYY-MM-DD HH:mm:ss'),
        ];
      } else {
        this.model.pageStartEndTime = [];
      }

      this.getEventList();
      if (this.model.id) {
        this.getSelectedModules(this.model.id);
      } else {
        this.arr2 = [1];
        this.pageModuleIds = [];
      }

      this.getBannerList();
      this.getRuleList();
      this.getHorseList();
      //this.getCardList();
    },

    close() {
      this.$emit('close');
      this.visible = false;
    },

    handleOk() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let httpurl = '';
          if (!this.model.id) {
            httpurl += this.url.add;
          } else {
            httpurl += this.url.edit;
          }
          let formData = Object.assign(this.model, values);
          formData.pageCommonConfigFlag =
            that.pageCommonConfigFlag === true ? '1' : '0';
          formData.pageStopFlag = that.pageStopFlag === true ? '1' : '0';
          formData.pageGoldFlag = that.pageGoldFlag === true ? 1 : 0;
          console.log(formData.pageStartEndTime);
          if (
            formData.pageStartEndTime &&
            formData.pageStartEndTime.length !== 0
          ) {
            formData.pageStartEndTime =
              formData.pageStartEndTime[0].format('YYYY-MM-DD HH:mm:ss') +
              '~' +
              formData.pageStartEndTime[1].format('YYYY-MM-DD HH:mm:ss');
          } else {
            formData.pageStartEndTime = '';
          }
          if (formData.pageHorseRaceLamp) {
            formData.pageHorseRaceLamp = formData.pageHorseRaceLamp.toString();
          }
          if (formData.pageBanner) {
            formData.pageBanner = formData.pageBanner.toString();
          }
          /*if (formData.pageProductCard){
              formData.pageProductCard = formData.pageProductCard.toString();
            }*/
          formData.pageModuleIds = JSON.stringify(that.pageModuleIds);
          formData.pageStopImg = this.fileList;
          console.log('表单提交数据', formData);
          postTag(httpurl, formData)
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.confirmLoading = false;
              that.close();
            });
        }
      });
    },

    handleCancel() {
      this.close();
    },

    popupCallback(row) {
      this.form.setFieldsValue(
        pick(
          row,
          'pageName',
          'pageDescribe',
          'pageCommonConfigFlag',
          'pageStopFlag',
          'pageRules',
          'pageHorseRaceLamp',
          'pageBanner',
          'pageStartEndTime',
          'pageStopType',
          'pageStopMessage',
          'pageStopImg',
          'pageStopJumpUrl'
        )
      );
    },

    range(start, end) {
      const result = [];
      for (let i = start; i < end; i++) {
        result.push(i);
      }
      return result;
    },

    disabledDate(current) {
      return current && current < moment().subtract(1, 'days'); //当天之前的不可选，不包括当天
    },

    disabledRangeTime(_, type) {
      if (type === 'start') {
        return {
          disabledHours: () => this.range(0, 60).splice(4, 20),
          disabledMinutes: () => this.range(30, 60),
          disabledSeconds: () => [55, 56],
        };
      }
      return {
        disabledHours: () => this.range(0, 60).splice(20, 4),
        disabledMinutes: () => this.range(0, 31),
        disabledSeconds: () => [55, 56],
      };
    },

    changeHandler(e) {
      this.pageCommonConfigFlag = e;
    },

    changeHandler2(e) {
      this.pageStopFlag = e;
    },

    changeHandler3(e) {
      this.pageGoldFlag = e;
    },

    fieldValue(e) {
      if (e === 1) {
        this.stopTextShow = true;
        this.stopImgShow = false;
      } else if (e === 2) {
        this.stopImgShow = true;
        this.stopTextShow = false;
      } else {
        this.stopImgShow = false;
        this.stopTextShow = false;
      }
    },

    editInitFields(model) {
      if (model.pageCommonConfigFlag === '0') {
        this.pageCommonConfigFlag = false;
      } else {
        this.pageCommonConfigFlag = true;
      }

      if (model.pageStopFlag === '0') {
        this.pageStopFlag = false;
      } else {
        this.pageStopFlag = true;
      }

      // if (model.pageGoldFlag === 1) {
      //   this.pageGoldFlag = true;
      // } else {
      //   this.pageGoldFlag = false;
      // }

      if (model.pageStopType === '1') {
        this.pageStopType = '1';
        this.stopTextShow = true;
        this.stopImgShow = false;
      } else if (model.pageStopType === '2') {
        this.pageStopType = '2';
        this.stopImgShow = true;
        this.stopTextShow = false;
      } else {
        this.pageStopType = '0';
        this.stopImgShow = false;
        this.stopTextShow = false;
      }
    },

    /**获取活动列表*/
    getEventList() {
      let getUrl =
        process.env.VUE_APP_CMS_MARKETING +
        '/activity/getEventList';
      getAction(getUrl).then((res) => {
        if (res.success) {
          this.moduleList = res.result;
        }
      });
    },

    /**获取规则列表*/
    getRuleList() {
      let getUrl =
        process.env.VUE_APP_CMS_MARKETING + '/marketActivityRule/list';
      getAction(getUrl).then((res) => {
        if (res.success) {
          this.ruleList = res.result.records;
        }
      });
    },

    /**获取跑马灯列表*/
    getHorseList() {
      let getUrl = process.env.VUE_APP_CMS_CONTENT + '/horse/race/list';
      getAction(getUrl).then((res) => {
        if (res.success) {
          this.horseRaceLampList = res.result.records;
        }
      });
    },

    /**获取banner列表*/
    getBannerList() {
      let getUrl = process.env.VUE_APP_CMS_CONTENT + '/cont/banner/list';
      getAction(getUrl).then((res) => {
        if (res.success) {
          this.bannerList = res.result.records;
        }
      });
    },

    /**获取产品卡列表*/
    getCardList() {
      let getUrl =
        process.env.VUE_APP_GATEWAY_URL +
        process.env.VUE_APP_CMS_MARKETING +
        '/product/getProductList';
      getAction(getUrl).then((res) => {
        if (res.success) {
          this.cardsList = res.result;
        }
      });
    },

    /**获取已有的模块配置*/
    getSelectedModules(modelId) {
      this.confirmLoading = true;
      this.arr2 = [];
      this.pageModuleIds = [];
      getAction(this.url.getMiddleByPageId, { pageId: modelId }).then((res) => {
        if (res.success) {
          if (res.result.length !== 0) {
            console.log(res.result);
            //this.arr2 = res.result.length;
            res.result.forEach((item) => {
              if (item.pageModuleId.indexOf(',') !== -1) {
                this.pageModuleIds.push(item.pageModuleId.split(','));
              } else {
                this.pageModuleIds.push(item.pageModuleId);
              }
              this.arr2.push(this.pageModuleIds);
            });
            //this.pageModuleIds = this.arr2;
            console.log(this.arr2);
          } else {
            this.arr2 = [1];
            this.pageModuleIds = [];
          }
          this.confirmLoading = false;
        }
      });
    },

    handleAddModules() {
      let newarr2 = [1];
      this.arr2 = this.arr2.concat(newarr2);
      console.log(this.arr2);
    },

    handleDelModules(index) {
      console.log(index);
      this.arr2.splice(index, 1);
      this.pageModuleIds.splice(index, 1);
    },

    handleAddOk() {
      //增加模块，入库
      const that = this;
      if (that.pageModuleIds.length === 0 || !that.modelId) {
        that.$message.error('添加失败,缺少参数!');
      }

      let paprms = {
        pageId: that.modelId,
        pageModuleIds: JSON.stringify(that.pageModuleIds),
      };
      console.log('提交参数pageId:' + paprms.pageId);
      console.log('提交参数pageModuleIds:' + paprms.pageModuleIds);
      httpAction(that.url.updateMiddle, paprms, 'put').then((res) => {
        if (res.success) {
          that.$message.success(res.message);
          that.$emit('ok');
        } else {
          that.$message.warning(res.message);
        }
      });
    },

    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    handleImageList(fileList) {
      this.fileList = fileList.fileName;
      console.log(fileList);
      this.form.setFieldsValue({
        pageStopImg: process.env.VUE_APP_FILE_PATH + fileList.fileName,
      });
    },
  },
};
</script>
<style scoped>
.drawer-bootom-button {
  position: absolute;
  bottom: -8px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
